import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'نستخدم ملفات تعريف الارتباط',
    description:
      'نستخدم ملفات تعريف الارتباط والتقنيات المشابهة لتشغيل هذه التجربة. ملفات تعريف الارتباط الضرورية للغاية مفعّلة دائمًا.',
    allow_label: 'قبول جميع ملفات تعريف الارتباط',
    reject_label: 'الضرورية للغاية فقط',
    settings_label: 'إعدادات ملفات تعريف الارتباط',
    policy_link_label: 'سياسة الخصوصية وملفات تعريف الارتباط',
    categories_label: 'الفئات',
    always_on_label: 'مفعّلة دائمًا',
    required_label: 'مطلوبة',
    save_preferences_label: 'حفظ التفضيلات',
    close_label: 'إغلاق',
    allow_all_optional_categories_label: 'السماح بجميع الفئات الاختيارية',
    settings_title: 'إعدادات ملفات تعريف الارتباط',
    settings_description:
      'نستخدم ملفات تعريف الارتباط والتقنيات المشابهة لتشغيل هذه التجربة. ملفات تعريف الارتباط الضرورية للغاية مفعّلة دائمًا.',
    save_error: 'تعذر حفظ اختيار الخصوصية. يرجى المحاولة مرة أخرى.'
  },
  categories: {
    strictly_necessary: { name: 'ضرورية للغاية', purpose: 'مطلوبة لتقديم هذه التجربة ولا يمكن إيقافها.' },
    analytics: { name: 'التحليلات', purpose: 'تقيس كيفية استخدام الزوار لهذه التجربة لتحسين الأداء.' },
    marketing: { name: 'التسويق', purpose: 'تدعم الإعلانات والتسويق اللذين يختارهما المنظم.' }
  }
};

export default locale;
